/**
 * LiveKitRoom Wrapper
 * 
 * This file re-exports the LiveKitRoom from the SDK package.
 * The SDK is initialized in src/config/livekitSdkInit.ts
 */

// Import SDK styles (using absolute path from workspace root)
import '../../../../../../packages/livekit-meeting-sdk/src/components/LiveKit/LiveKitLayout.css';

// Make sure SDK is initialized
import { initLiveKitSDK } from '../../../../../Config/livekitSdkInit';

// Initialize SDK (idempotent - safe to call multiple times)
if (typeof window !== 'undefined') {
    try {
        initLiveKitSDK();
    } catch (error) {
        // SDK might already be initialized, that's okay
        console.log('LiveKit SDK already initialized or error:', error);
    }
}

// Re-export everything from the SDK
export { LiveKitRoom as default } from '@hosaksham/livekit-meeting-sdk';
export * from '@hosaksham/livekit-meeting-sdk';

